import React , {Component} from 'react';
import axios from 'axios';
import $ from 'jquery'
import './PSITRESBuilder.css'
import '../../css/normalize.css'
import '../../css/grid.css'
import '../../css/grid.css'
import Navigation from '../../components/Navigation/Navigation.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()

class PSITRESBuilder extends Component{

  constructor(props) {
    super(props);
  }

  state = {
    ship_name : null,
    year : [],
    selected_year : null,
    month : [],
    selected_month : null,
    day : [],
    selected_day : null,
    hour : [],
    selected_hour : null,
    minute : [],
    selected_minute : null,
    seconds : [],
    selected_seconds : null,
    stereo_id:[],
    selected_stereo:null,
    left_image_id : "",
    right_image_id: "",
    left_image : [],
    right_image : [],
    image_analysis : [],
    selector : null,
    left_output_image: [],
    right_output_image: [] ,
    view_options:[],
    logged_in: false,
    api_key: "",
    endpoint: 'https://vims.cis.udel.edu/geography/seaice/services/',
  }

  reset = (param) =>{
    if($('#result_container').is(':visible')){
      $('#result_container').hide();
    }
    $('#processed_result').hide();
    let states = Object.keys(this.state);
    let temp_obj = {}
    for(var i = 0; i < states.length ; i++){
      let key = states[i]
      let value = this.state[states[i]]
      if(param[key] === undefined && key !== 'image_analysis' && key !== 'endpoint'){ //reset all parameters not present in param
        if($.isArray(value)){
          temp_obj[key] = []
        }else{
          temp_obj[key] = null
        }
      }
    }
    this.setState(temp_obj)
  }


  getYears = (ship_name) => {
    this.reset({'ship_name' : false})
    let choosen_link = '#' + ship_name
    let url =  this.state.endpoint + 'getyear/' +
    'ship='  + ship_name +
    '&key=' + localStorage.getItem('api_key')
    axios({
      method: 'get',
      url: url
      }).then( (response) => {
        console.log(response.data.year);
        let year = response.data.year
        console.log('response')
        this.setState(
          {ship_name: ship_name, year : year } )
          $('#year').trigger('click')
      })
      .catch( (error) => {
        console.log(error);
      });
  }


  getMonths = () => {
      this.reset({'ship_name' : false , 'year' : false})
      let year = document.getElementById('year').value;
      let ship_name = this.state.ship_name;

      let url = this.state.endpoint + 'getmonth/' +
      'ship=' + ship_name +
      '&year=' + year +
      '&key=' + localStorage.getItem('api_key')

      console.log(url);
      if (  year !== "null" ){
        axios({
          method: 'get',
          url: url,
        }).then( (response) => {
            console.log(response.data.month);
            let month = response.data.month
            this.setState( {
              selected_year : year,
              month : month
             })
            $('#month').trigger('click')
          })
          .catch( (error) => {
            console.log(error);
          });
      }
  }

  getDays = () => {
    this.reset({
      'ship_name' : false ,
      'year' : false ,
      'selected_year' : false,
      'month' : false})
    let month =  document.getElementById('month').value;
    let ship_name = this.state.ship_name;
    let year = this.state.selected_year;
    let url = this.state.endpoint + 'getday/' +
    "ship=" + ship_name +
    "&year=" + year +
    "&month= " + month +
    '&key=' + localStorage.getItem('api_key')

    if (  month !== "null" ){
      axios({
        method: 'get',
        url: url
      }).then( (response) => {
          console.log(response.data.day);
          let day = response.data.day
          this.setState( {
              selected_month: month ,
              day : day,
           })
           $('#day').trigger('click')
        })
        .catch( (error) => {
          console.log(error);
        });
    }
  }

  getHours = () => {
    this.reset({
      'ship_name' : false ,
      'year' : false ,
      'selected_year' : false ,
      'month' : false ,
      'selected_month' : false,
      'day': false })
    let day = document.getElementById('day').value;
    let ship_name = this.state.ship_name;
    let year = this.state.selected_year;
    let month = this.state.selected_month;
    let url = this.state.endpoint + 'gethour/' +
    "ship=" + ship_name +
    "&year=" + year +
    "&month= " + month +
    "&day=" +  day +
    '&key=' + localStorage.getItem('api_key')

    if (  day !== "null" ){
      axios({
        method: 'get',
        url: url
      }).then( (response) => {
          console.log(response.data.hour);
          let hour = response.data.hour
          this.setState( {
            selected_day : day , hour : hour } )
          $('#hour').trigger('click')

        })
        .catch( (error) => {
          console.log(error);
        });
    }
  }

  getMinutes = () => {
    this.reset({
      'ship_name' : false ,
      'year' : false ,
      'selected_year' : false ,
      'month' : false ,
      'selected_month' : false,
      'day': false,
      'selected_day' : false,
      'hour' : false
    })
    let hour = document.getElementById('hour').value;
    let ship_name = this.state.ship_name;
    let year = this.state.selected_year;
    let month = this.state.selected_month;
    let day = this.state.selected_day;
    let url = this.state.endpoint  + 'getminute/' +
    "ship=" + ship_name +
    "&year=" + year +
    "&month= " + month +
    "&day=" +  day +
    "&hour=" + hour +
    '&key=' + localStorage.getItem('api_key')

    console.log(url)
    if (  hour !== "null" ){
      axios({
        method: 'get',
        url: url
      }).then( (response) => {
          console.log(response.data.minute);
          let minute = response.data.minute
          this.setState( { selected_hour : hour , minute : minute } )
          $('#minute').trigger('click')
        })
        .catch( (error) => {
          console.log(error);
        });
    }
  }

  getSeconds = () => {
    this.reset({
      'ship_name' : false ,
      'year' : false ,
      'selected_year' : false ,
      'month' : false ,
      'selected_month' : false,
      'day': false,
      'selected_day' : false,
      'hour' : false,
      'selected_hour' : false ,
      'minute' : false,
    })
    let minute = document.getElementById('minute').value;
    let ship_name = this.state.ship_name;
    let year = this.state.selected_year;
    let month = this.state.selected_month;
    let day = this.state.selected_day;
    let hour = this.state.selected_hour;
    let url = this.state.endpoint + 'getsecond/' +
    "ship=" + ship_name +
    "&year=" + year +
    "&month=" + month +
    "&day=" +  day +
    "&hour=" + hour+
    "&minute=" + minute +
    '&key=' + localStorage.getItem('api_key')

    console.log(url)
    if (  minute !== "null" ){
      axios({
        method: 'get',
        url: url
      }).then( (response) => {
          console.log(response.data.seconds);
          let seconds = response.data.seconds
          this.setState( { selected_minute : minute , seconds : seconds } )
          $('#seconds').trigger('click')

        })
        .catch( (error) => {
          console.log(error);
        });
    }
  }

  getStereoID = () => {
    this.reset({
      'ship_name' : false ,
      'year' : false ,
      'selected_year' : false ,
      'month' : false ,
      'selected_month' : false,
      'day': false,
      'selected_day' : false,
      'hour' : false,
      'selected_hour' : false ,
      'minute' : false,
      'selected_minute' : false ,
      'seconds' : false
    })

    let seconds = document.getElementById('seconds').value;
    console.log('seconds' + seconds)
    let ship_name = this.state.ship_name;
    let year = this.state.selected_year;
    let month = this.state.selected_month;
    let day = this.state.selected_day;
    let hour = this.state.selected_hour;
    let minute = this.state.selected_minute;

    let url = this.state.endpoint + 'getstereo/' +
    "ship=" + ship_name +
    "&year=" + year +
    "&month=" + month +
    "&day=" +  day +
    "&hour=" + hour+
    "&minute=" + minute+
    "&seconds=" + seconds +
    '&key=' + localStorage.getItem('api_key')


    console.log(url)
    if (  seconds !== "null" ){
      axios({
        method: 'get',
        url: url
      }).then( (response) => {
          console.log(response.data.stereo_id);
          let stereo_id = response.data.stereo_id;
          let image_analysis = [
            'Algae Segmentation' ,
            'Ice Melt Segmentation' ,
            'Open Water Segmentation',
            'Disparity'
          ]
          this.setState( { selected_seconds : seconds , stereo_id : stereo_id , image_analysis: image_analysis  } )
          $('#stereo_id').trigger('click');

        })
        .catch( (error) => {
          console.log(error);
        });
    }
  }

  getLeftImage = () => {

    this.reset({
      'ship_name' : false ,
      'year' : false ,
      'selected_year' : false ,
      'month' : false ,
      'selected_month' : false,
      'day': false,
      'selected_day' : false,
      'hour' : false,
      'selected_hour' : false ,
      'minute' : false,
      'selected_minute' : false ,
      'seconds' : false,
      'selected_seconds' : false,
      'stereo_id' : false
    })

    let stereo_id = document.getElementById('stereo_id').value;
    let ship_name = this.state.ship_name;
    let year = this.state.selected_year;
    let month = this.state.selected_month;
    let day = this.state.selected_day;
    let hour = this.state.selected_hour;
    let minute = this.state.selected_minute;
    let seconds = this.state.selected_seconds;

    let url = this.state.endpoint + 'getleftimage/' +
    "ship=" + ship_name +
    "&year=" + year +
    "&month=" + month +
    "&day=" +  day +
    "&hour=" + hour+
    "&minute=" + minute+
    "&seconds=" + seconds +
    "&stereo_id=" + stereo_id +
    '&key=' + localStorage.getItem('api_key')

    return axios.get( url )

  }


  getRightImage = () => {

    let stereo_id = document.getElementById('stereo_id').value;
    let ship_name = this.state.ship_name;
    let year = this.state.selected_year;
    let month = this.state.selected_month;
    let day = this.state.selected_day;
    let hour = this.state.selected_hour;
    let minute = this.state.selected_minute;
    let seconds = this.state.selected_seconds;

    let url = this.state.endpoint + 'getrightimage/' +
    "ship=" + ship_name +
    "&year=" + year +
    "&month=" + month +
    "&day=" +  day +
    "&hour=" + hour+
    "&minute=" + minute+
    "&seconds=" + seconds +
    "&stereo_id=" + stereo_id +
    '&key=' + localStorage.getItem('api_key')

     return axios.get( url )
  }


  getBoth = () => {
      axios.all([this.getLeftImage(), this.getRightImage()]).then( axios.spread((response1, response2) => {
          console.log(response1, response2);
          let left_image_id = response1.data.left_image_id
          let right_image_id = response2.data.right_image_id

          let url_left = this.state.endpoint + 'dwnldimg/'+
          "ship=" + this.state.ship_name + '&' +
          "img_id=" + left_image_id +
          '&key=' + localStorage.getItem('api_key')


          let url_right = this.state.endpoint + 'dwnldimg/'+
          "ship=" + this.state.ship_name + '&' +
          "img_id=" + right_image_id +
          '&key=' + localStorage.getItem('api_key')


          axios({
            method: 'get',
            url: url_left,
            responseType: 'blob',
          }).then( (response) => {
            console.log(response.data)
            let left_image = window.URL.createObjectURL(new Blob([response.data]));
            this.setState({left_image : left_image, left_image_id: left_image_id})

          }).catch( (error) => {
              console.log(error);
          });

          axios({
            method: 'get',
            url: url_right,
            responseType: 'blob',
          }).then( (response) => {
            console.log(response.data)
            let right_image = window.URL.createObjectURL(new Blob([response.data]));
            this.setState({right_image : right_image, right_image_id : right_image_id})

          }).catch( (error) => {
              console.log(error);
          });



          $('#result_container').show();
        }));
  }

  doImageAnalysis = () => {
    $('#processed_result').hide();
    $('#processed_result_container').addClass('loader');
    $('#processed_result_container').addClass('centeralign')

    let operation = document.getElementById('image_analysis').value;
    console.log('operation',operation)
    if (operation.toString() !== "4"){
      let url = this.state.endpoint + 'imageanalysis/';
      let view_options = ['View Left Image' , 'View Right Image'];
      axios({
        method: 'post',
        url: url,
        data: {
          ship_name: this.state.ship_name,
          left_image_id: this.state.left_image_id,
          right_image_id: this.state.right_image_id,
          selector : operation,
        }
      }).then( (response) => {
          console.log(response.data)
          let url_left = this.state.endpoint + 'dwnldanalyimg/'+
          "img_id=" + response.data.result_left_image +
          '&key=' + localStorage.getItem('api_key')


          let url_right = this.state.endpoint + 'dwnldanalyimg/'+
          "img_id=" + response.data.result_right_image +
          '&key=' + localStorage.getItem('api_key')

          axios({
            method: 'get',
            url: url_left,
            responseType: 'blob',
          }).then( (response) => {
            console.log(response.data, url_left)
            let left_output_image = window.URL.createObjectURL(new Blob([response.data]));
            this.setState({
              left_output_image : left_output_image,
              view_options:view_options,
            })
          }).catch( (error) => {
              console.log(error);
          });

          axios({
            method: 'get',
            url: url_right,
            responseType: 'blob',
          }).then( (response) => {
            console.log(response.data, url_right)
            let right_image_output = window.URL.createObjectURL(new Blob([response.data]));
            this.setState({
              right_output_image : right_image_output,
              view_options:view_options,
            })
            $('#processed_result_container').removeClass('loader')
            $('#processed_result_container').removeClass('centeralign')
            $('#processed_result').show();
          })
          }).catch( (error) => {
              console.log(error);
          });
        }else{
          console.log('Disparity')
          let url = this.state.endpoint + 'imageanalysis/';
          let view_options = ['View Left Image' , 'View Right Image'];
          axios({
            method: 'post',
            url: url,
            data: {
              ship_name: this.state.ship_name,
              left_image_id: this.state.left_image_id,
              right_image_id: this.state.right_image_id,
              selector : operation,
            }
          }).then( (response) => {
          let url = this.state.endpoint + 'dwnldanalyimg/'+
          "img_id=" + response.data.filename_out +
          '&key=' + localStorage.getItem('api_key')

          axios({
            method: 'get',
            url: url,
            responseType: 'blob',
          }).then( (response) => {
            console.log(response.data, url)
            let left_output_image = window.URL.createObjectURL(new Blob([response.data]));
            this.setState({
              left_output_image : left_output_image,
              view_options:view_options,
            })
            $('#processed_result_container').removeClass('loader')
            $('#processed_result_container').removeClass('centeralign')
            $('#processed_result').show();
          }).catch( (error) => {
              console.log(error);
          });
        })
      }
}
  render(){
    console.log(JSON.stringify(this.state))

    let years_options = this.state.year.map( (year) => {
      return (
        <option key = {year.toString()} value = {year.toString()}> {year.toString()}</option>
      )
    })

    let month_options = this.state.month.map( (month) => {
      return (
        <option key = {month.toString()} value = {month.toString()}> {month.toString()}</option>
      )
    })

    let day_options = this.state.day.map( (day) => {
      return (
        <option key = {day.toString()} value = {day.toString()}> {day.toString()}</option>
      )
    })

    let hour_options = this.state.hour.map( (hour) => {
      return (
        <option key = {hour.toString()} value = {hour.toString()}> {hour.toString()}</option>
      )
    })

    let minute_options = this.state.minute.map( (minute) => {
      return (
        <option key = {minute.toString()} value = {minute.toString()}> {minute.toString()}</option>
      )
    })

    let seconds_options = this.state.seconds.map( (seconds) => {
      return (
        <option key = {seconds.toString()} value = {seconds.toString()}> {seconds.toString()}</option>
      )
    })

    let stereo_options = this.state.stereo_id.map( (stereo_id) => {
      return (
        <option key = {stereo_id.toString()} value = {stereo_id.toString()}> {stereo_id.toString()}</option>
      )
    })


    let image_analysis = this.state.image_analysis.map( (image_analysis, index ) =>  {

      return(
        <option key = {image_analysis.toString()} value = {index+1} name = {image_analysis.toString()}>{image_analysis.toString()}</option>
      )
    })


    let view_result_options = this.state.view_options.map( (view_option) => {
      return (
        <option key = {view_option.toString()} value = {view_option.toString()}> {view_option.toString()}</option>
      )
    })

    return (
      <div>
        <div className = "rows">
        <div className = "col span-1-of-7">
          <select id = "year" name="year"
            onChange= { () => this.getMonths() }
            onClick = {() => this.triggerClick('#year' , (this.state.year.length + 1))}>
            <option value ="null">-Year--</option>
            {years_options}
          </select>
        </div>
        <div className = "col span-1-of-7">
          <select id = "month" name="month"
            onChange= {() => this.getDays()}
            onClick = {() => this.triggerClick('#month' , (this.state.month.length + 1))}>
            <option value ="null">--Month--</option>
            {month_options}
          </select>
        </div>
        <div className = "col span-1-of-7">
          <select id = "day" name="day"
            onChange= { () => this.getHours() }
            onClick = {() => this.triggerClick('#day' , (this.state.day.length + 1))} >
            <option value ="null">--Day--</option>
            {day_options}
          </select>
        </div>
        <div className = "col span-1-of-7">
          <select id = "hour" name="hour"
            onChange= {() => this.getMinutes()}
            onClick = {() => this.triggerClick('#hour' , (this.state.hour.length + 1))}>
            <option value ="null">--Hour--</option>
            {hour_options}
          </select>
        </div>
        <div className = "col span-1-of-7">
          <select id = "minute" name="minute"
            onChange= {() => this.getSeconds()}
            onClick = {() => this.triggerClick(  '#minute' , (this.state.minute.length + 1))}>
            <option value ="null">--Minute--</option>
            {minute_options}
          </select>
        </div>
        <div className = "col span-1-of-7">
          <select id = "seconds" name="seconds"
            onChange= {() => this.getStereoID()}
            onClick = {() => this.triggerClick('#seconds' , (this.state.seconds.length + 1))}>
            <option value ="null">--Second--</option>
            {seconds_options}
          </select>
        </div>
        <div className = "col span-1-of-7">
          <select id = "stereo_id" name="stereo_id"
            onChange= {() => this.getBoth()}
            onClick = {() => this.triggerClick('#stereo_id' , (this.state.stereo_id.length + 1))}>
            <option value ="null">--StereoID--</option>
            {stereo_options}
          </select>
        </div>
        </div>
        <div id = "result_container" className = "margin">
          <div>
            <div className = " container col span-1-of-2">
              <div className = "image col span-1-of-2">
                <p>Left Stereo Image</p>
                <img src = {this.state.left_image} height = "100" width = "100"/>
              </div>
              <div className = "image col span-1-of-2">
                <p> Right Stereo Image </p>
                <img src = {this.state.right_image} height = "100" width = "100"/>
              </div>
              <div>
                <select id = "image_analysis" onClick = {() => this.doImageAnalysis()} >
                  <option value= "null" name = "null">--Select Operation</option>
                  {image_analysis}
                </select>
              </div>
            </div>
            {(document.getElementById('image_analysis') == null) || (document.getElementById('image_analysis').value.toString()) !== "4" ?
            <div className = "container col span-1-of-2">
              <div id ="processed_result_container" className = "centeralign">
              </div>
              <div id = "processed_result">
                <div className = "image col span-1-of-2">
                  <p>Left Stereo Image Result</p>
                  <img src = {this.state.left_output_image} height = "100" width = "100"/>
                </div>
                <div className = "image col span-1-of-2">
                  <p> Right Stereo Image Result </p>
                  <img src = {this.state.right_output_image} height = "100" width = "100"/>
                </div>
              </div>
            </div>:
            <div className = "container col span-1-of-2">
              <div className = "centeralign image col span-1-of-2">
                <p>Disparity Map</p>
                  <img style = {{textAlign: "center"}} src = {this.state.left_output_image} height = "100" width = "100"/>
              </div>
            </div>
          }

          </div>
        </div>
      </div>
    )
  }

  triggerClick(choosen , size){
      console.log('choosen' , $(choosen).val())
      if($(choosen).val() === 'null'){
        var drop_down=$(choosen);
        drop_down.show();
        if(size > 10){
          drop_down[0].size=10;
        }else{
          drop_down[0].size = size;
        }
      }
      if($(choosen).val() !== 'null'){
        var drop_down=$(choosen);
        drop_down[0].size=1;
      }
  }


  viewResult(){
    let selected_option = document.getElementById('image_analysis_view').value;
    if(selected_option === 'View Left Image'){
      window.open(this.state.left_output_image, "_blank")
    }

    if(selected_option === 'View Right Image'){
      window.open(this.state.right_output_image, "_blank")
    }


  }

  componentDidMount(){
    let input_link = this.props.match.path.toString();
    console.log('Prop',this.props)
    let ship_name = input_link.substring(9,input_link.length);
    console.log(ship_name);
    if(ship_name === 'SKQ2015'){
      ship_name = 'SKP2015' ;
    }
    else{
      ship_name = 'OATRC';
    }
    this.getYears(ship_name);
    $('#result_container').hide();
    $('#processed_result').hide();
    let logged_in = JSON.parse(localStorage.getItem('logged_in'));
    let api_key = localStorage.getItem('api_key')
    console.log(api_key)
    console.log(logged_in)
    if (logged_in){
      this.setState({
        logged_in: logged_in,
        api_key:api_key
      })
    }else{
      toast('You must be logged in to analyse the dataset.', { autoClose: 3000, hideProgressBar: true })
      this.setState({
        logged_in: logged_in,
        api_key:"",
      })
    }

  }

}

export default PSITRESBuilder;



// WEBPACK FOOTER //
// ./src/container/PSITRESBuilder/PSITRESBuilder.js